import axios from "axios";
import React, {useEffect, useState, useRef, Fragment} from "react";
import {Link, NavLink, useParams, useNavigate, useLocation} from "react-router-dom"
import { render } from "react-dom";
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import EditIcon from '@mui/icons-material/Edit';
import clientconfigwebapp, {
    empty_bk,
    convert_to_english_strhk,
    scrollTo_uphk,
    check_login_appbk,
    Token_get_appbk,
    redirectbh_typeb,
    FormatNumberByhkh,
    Cart_get_list_product,
} from '../../clientconfigwebapp';
import { ToastContainer, toast } from 'react-toastify';

import Master_Front from "../../pages/Master_Front";

import "../../components/assets/css/profile.css"

import ReactFullPageLoadinghk from "../../components/layaout/LoadingFullpagehk";
import Menu_panel from "../../components/layaout/Menu-panel";

import Grid from '@mui/material/Grid';
import {Button} from "@mui/material";
import LazyLoad from "react-lazy-load";
import banner from "../../assets/img/Rectangle 305.png";
import Slider_show_home from "../../components/Sliders_box/Slider_show_home";



const serialize = require('form-serialize');


const My_address = () => {

    const location_get_urlbk = useLocation();
    const redirect_navigate = useNavigate();
    const [loadinghkfullshow, Setloadinghkfullshow] = useState("false");

    /*  start profile */
    const [wallet_balance, setData_wallet_balance] = useState('0');
    const [first_name_profile,setData_first_name_profile] = useState('');
    const [last_name_profile,setData_last_name_profile] = useState('');
    const [list_my_address,setData_list_my_address] = useState([]);
    /*  end profile */


    const [data_full_get,setData_full_data_get] = useState([]);

    const [address_full,set_address_full] = useState('');
    const [title_post,set_title_post] = useState('');
    const [phone_user_address,set_phone_user_address] = useState('');
    const [id_address_edit,set_id_address_edit] = useState('');
    const [type_req,set_type_req] = useState('');

    useEffect(() => {
        scrollTo_uphk();
        if(check_login_appbk()==false){
           redirectbh_typeb(String(clientconfigwebapp.webappurl) + "login" );
            return false;
        }
        Load_api_page();

    }, [location_get_urlbk]);

    const Load_api_page= () => {

        if(check_login_appbk()==false){ redirectbh_typeb(String(clientconfigwebapp.webappurl) + "login" );}

        const config = {
            headers: { Authorization: `Bearer ${Token_get_appbk()}` }
        };

        Setloadinghkfullshow("true");

        axios.post(`${clientconfigwebapp.siteurl}api/v1/dashboard-get`,null,config)
            .then((res) => {
///console.log(res.data);
                Setloadinghkfullshow("false");
                if(String(res.data).length > 0) {


                    if(String(res.data.data)=="login-show"){ redirectbh_typeb(String(clientconfigwebapp.webappurl) + "login" );  } ////dddddd

                    if(String(res.data.data).length > 0) {  setData_full_data_get(res.data.data); }
                    if(String(res.data.wallet_inventory).length > 0) {  setData_wallet_balance(res.data.wallet_inventory); }
                    if (!empty_bk(res.data.first_name_profile)) { setData_first_name_profile(res.data.first_name_profile); localStorage.setItem('first_name_Get',res.data.first_name_profile);    }
                    if (!empty_bk(res.data.last_name_profile)) { setData_last_name_profile(res.data.last_name_profile); localStorage.setItem('last_name_Get',res.data.last_name_profile);    }


                      if(String(res.data.data.list_my_address).length > 0) {  setData_list_my_address(res.data.data.list_my_address); }







                }else{
                    if(String(res.data.msgwebapp).length > 0)  toast.error(res.data.msgwebapp, {position: "top-center", autoClose: 5000, hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined,});
                }

            }).catch((err) =>{
            Setloadinghkfullshow("false");
            toast.error('خطای اتصال به سرور کد 435346', {position: "top-center", autoClose: 5000, hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined,});
        });





    }


    const ModalBack = useRef();
    const Element_popups_address_new = useRef();

    function popups_address_new_OpenHandler () {
        Element_popups_address_new. current.style.right = "27%";

   
        ModalBack.current.style.display = "block";

        set_id_address_edit("");
        set_address_full("");
        set_title_post("");
        set_phone_user_address("");
        set_type_req("");

    }

    function popups_address_new_CloseHandler () {
        Element_popups_address_new. current.style.right = "-93vw";
        ModalBack.current.style.display = "none";
        set_id_address_edit("");
        set_address_full("");
        set_title_post("");
        set_phone_user_address("");
        set_type_req("");
    }


    function popups_address_edit_OpenHandler (item_post_get) {
        Element_popups_address_new. current.style.right = "27%";
        ModalBack.current.style.display = "block";
       //// console.log(item_post_get,"item_post_get");
        set_type_req("edit");

        set_address_full(String(convert_to_english_strhk(item_post_get.address_full)));
        set_title_post(String(convert_to_english_strhk(item_post_get.title_post)));
        set_phone_user_address(String(convert_to_english_strhk(item_post_get.phone_user_address)));
        set_id_address_edit(String(convert_to_english_strhk(item_post_get.id_post)));

    }


    function popups_address_del_OpenHandler (item_post_get) {
        Element_popups_address_new. current.style.right = "27%";
        ModalBack.current.style.display = "block";
        //// console.log(item_post_get,"item_post_get");
        set_type_req("del");

        set_address_full(String(convert_to_english_strhk(item_post_get.address_full)));
        set_title_post(String(convert_to_english_strhk(item_post_get.title_post)));
        set_phone_user_address(String(convert_to_english_strhk(item_post_get.phone_user_address)));
        set_id_address_edit(String(convert_to_english_strhk(item_post_get.id_post)));

    }


    const Handler_Chanche_address_full = (event) => {
        set_address_full(String(convert_to_english_strhk(event.target.value)));
    }

    const Handler_Chanche_title_post = (event) => { set_title_post(String(convert_to_english_strhk(event.target.value))); }

    const Handler_Chanche_phone_user = (event) => { set_phone_user_address(String(convert_to_english_strhk(event.target.value))); }



    const Handler_req_new_address_pr= () => {

        if(check_login_appbk()==false){ redirectbh_typeb(String(clientconfigwebapp.webappurl) + "login" ); }

        const config = {
            headers: { Authorization: `Bearer ${Token_get_appbk()}` }
        };

        Setloadinghkfullshow("true");


        let form_data = document.querySelector('#form_address_new');
        if (form_data != null) {

            let data_serialize = serialize(form_data);


            axios.post(`${clientconfigwebapp.siteurl}api/v1/panel/address-new-pr/`,data_serialize,config)
                .then((res) => {

                    Setloadinghkfullshow("false");

                    if(String(res.data).length > 0) {

                        if(String(res.data.data)=="login-show"){ redirectbh_typeb(String(clientconfigwebapp.webappurl) + "login" );   }



                        if(String(res.data.status)=="success"){
                            toast.success(res.data.msgwebapp, {position: "top-center", autoClose: 5000, hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined,});
                            redirectbh_typeb(String(clientconfigwebapp.webappurl ) + "panel/my-address");


                        }else{

                            if(String(res.data.msgwebapp).length > 0)  toast.error(res.data.msgwebapp, {position: "top-center", autoClose: 5000, hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined,});

                        }





                    }else{
                        if(String(res.data.msgwebapp).length > 0)  toast.error(res.data.msgwebapp, {position: "top-center", autoClose: 5000, hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined,});
                    }

                }).catch((err) =>{
                Setloadinghkfullshow("false");
                toast.error('خطای اتصال به سرور کد 6786324', {position: "top-center", autoClose: 5000, hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined,});
            });





        }






    }

    return (
        <>
            <Master_Front   wallet_balance={wallet_balance} first_name_profile={first_name_profile} last_name_profile={last_name_profile} >
                <ReactFullPageLoadinghk loadinghk={loadinghkfullshow}  />
                <ToastContainer />

                <div className="modal-back" ref={ModalBack}></div>


                <img src={banner} alt="banner" className='baner-panel'/>

                <section className='w-100 flexRowBetStart account-section-container'>




                    <Grid container direction="row" spacing={2} style={{paddingTop:"14px"}}>


                        <Grid  item className="item_inputbk" lg={3} md={3} sm={12} xs={12} style={{marginTop:"4px"}}>


                            <div className='account-aside'>
                                <Menu_panel wallet_balance={wallet_balance} first_name_profile={first_name_profile} last_name_profile={last_name_profile} />
                            </div>

                        </Grid>


                        <Grid  item className="item_inputbk" lg={9} md={9} sm={12} xs={12} style={{marginTop:"4px"}}>

                            <section className='account-content' style={{"paddingTop":"15px"}}>


                                <div style={{width: '100%',"marginBottom":"0px", paddingBottom: '0px', display: 'flex', flexFlow: 'row', justifyContent: 'space-between', alignItems: 'center'}}>
                                    <div ><span style={{color: 'var(--c2)', fontFamily: 'iran', fontSize: '19px', fontStyle: 'normal', fontWeight: 700, lineHeight: 'normal'}}>لیست آدرس‌های من</span></div>
                                    <div ><div className="d-flex align-center" style={{float: 'left'}}>
                                        <button onClick={popups_address_new_OpenHandler} className="btn-bh btn-bon-bh" type="button" style={{color: '#000', fontFamily: 'iran', fontSize: '15px', fontStyle: 'normal', fontWeight: 700, lineHeight: 'normal'}}>آدرس جدید +</button></div></div>
                                </div>




                                {  data_full_get.total_my_address > 0 && list_my_address.length > 0 ?  (

                                <Fragment>

                                    <Grid container direction="row" spacing={2} style={{paddingTop:"14px"}}>


                                        {

                                            list_my_address.map((item_post,index) => {

                                                return (





                                                    <Fragment>



                                                        <Grid  item className="box_address_panel" lg={6} md={6} sm={12} xs={12} style={{marginTop:"4px"}}>

                                                            <div className={"card-address_panel"}>
                                                                <span className="title_address_list"> {item_post.title_post} | {item_post.phone_user_address}  </span>
                                                                <span className="address_text_bk">{item_post.address_full}</span>

                                                                <div className={"item_icon_panel_address_list"}>
                                                                    <button type={"button"} onClick={() => popups_address_edit_OpenHandler(item_post)} ><EditIcon/></button>
                                                                    <button type={"button"} onClick={() => popups_address_del_OpenHandler(item_post)}  ><DeleteOutlineIcon/></button>
                                                                </div>
                                                            </div>


                                                        </Grid>

                                                    </Fragment>



                                                );

                                            })

                                        }





                                    </Grid>


                                </Fragment>

                                ) : (<Fragment>

                                    <span style={{"display":"block","textAlign":"center","paddingBottom":"32px","paddingTop":"32px"}}>آدرسی ثبت نکرده اید</span>

                                </Fragment>)   }















                            </section>


                        </Grid>






                    </Grid>






                </section>







                <section className="bk-modal-typea mini-modal-bk" style={{"paddingBottom":"20px",height:"auto"}} ref={Element_popups_address_new}>




                    <div style={{"paddingTop":"10px","paddingBottom":"10px","backgroundColor":"var(--v11)","display":"flex","marginLeft":"1%","borderRadius":"8px"}}>
                        <p  style={{"textAlign":"center","paddingTop":"11px","paddingBottom":"11px","display":"block","width":"100%","backgroundColor":"var(--v11)"}}>ثبت آدرس تحویل گیرنده سفارش</p>

                        <svg style={{"position":"relative","top":"6px","left":"12px"}} onClick={popups_address_new_CloseHandler} className="user-aside-close" width="13" height="14" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect width="16.392" height="2.04697" rx="1.02348" transform="matrix(0.631178 -0.775638 0.844744 0.53517 0 12.9045)" fill="#475569"/>
                            <rect width="16.3581" height="2.05087" rx="1.02543" transform="matrix(0.617496 0.786574 -0.853256 0.521493 1.80347 0)" fill="#475569"/>
                        </svg>
                    </div>




                    <form id="form_address_new" style={{"width":"98%"}}>

                        <input style={{display:"none"}} type={"text"} name={"id_address_edit"} value={id_address_edit}  />
                        <input style={{display:"none"}} type={"text"} name={"type_req"} value={type_req}  />

                        <div className="" style={{backgroundColor: "rgb(247, 247, 255)", borderRadius: 10, border: "2px dashed rgb(206, 206, 206)", padding: 15, marginTop: 19, height: 108 }}>
                            <span className="alert alert-warning" style={{ fontSize: 12, display: "inline-block", lineHeight: "1.6",color:"var(--8)" }}>ادرس محل تحویل سفارش را با کلیک کردن روی نقشه انتخاب کنید. (توجه نقشه بایدروی دومین اصلی سایت بیاد بالا تا لود شود،نیاز به تهیه اشتراک هستش){" "}</span>
                        </div>



                        <Grid container direction="row" spacing={2} style={{paddingTop:"9px"}}>

                            <Grid  item className="item_address_inputbk" lg={12} md={12} sm={12} xs={12} style={{marginTop:"2px"}}>
                                <label className="requirebk-input"  id={"address_full"} style={{"display":"block","marginBottom":"3px","marginRight":"9px"}}>آدرس دقیق</label>
                                <input value={address_full} onChange={Handler_Chanche_address_full}  type="text" name="address_full"  style={{"direction":"rtl","width":"100%","height":"46px"}} placeholder={"آدرس تحویل سفارش"} />
                            </Grid>

                            <Grid  item className="item_address_inputbk" lg={6} md={6} sm={6} xs={6} style={{marginTop:"4px"}}>
                                <label className="requirebk-input "  id={"title_ticket"} style={{"display":"block","marginBottom":"3px","marginRight":"9px"}}>عنوان آدرس</label>
                                <input value={title_post} onChange={Handler_Chanche_title_post}  type="text" name="title_post"  style={{"direction":"rtl","width":"100%","height":"46px"}} placeholder={"مثال : شرکت"} />
                            </Grid>


                            <Grid  item className="item_address_inputbk" lg={6} md={6} sm={6} xs={6} style={{marginTop:"4px"}}>
                                <label className="requirebk-input"  id={"title_ticket"} style={{"display":"block","marginBottom":"3px","marginRight":"9px"}}>شماره تماس (تحویل گیرنده)</label>
                                <input value={phone_user_address} onChange={Handler_Chanche_phone_user}  type="text" name="phone_user_address"  style={{"direction":"rtl","width":"100%","height":"46px"}} placeholder={"مثال : 091200000"} />
                            </Grid>






                        </Grid>

                        {
                            type_req=="del" ?  (
                                <React.Fragment>
                                    <button type={"button"} onClick={Handler_req_new_address_pr}  className={"btn-bh btn-black-bh"}   style={{"fontSize":"16px","marginTop":"20px","width":"100%","paddingTop":"14px","paddingBottom":"14px","fontFamily":"'iran'"}} >حذف آدرس</button>
                                </React.Fragment>


                            ) : (


                                <React.Fragment>
                                    <button type={"button"} onClick={Handler_req_new_address_pr}  className={"btn-bh btn-black-bh"}   style={{"fontSize":"16px","marginTop":"20px","width":"100%","paddingTop":"14px","paddingBottom":"14px","fontFamily":"'iran'"}} >ثبت آدرس</button>
                                </React.Fragment>

                            )

                        }







                    </form>



                </section>



            </Master_Front>

        </>
    );
}


export default My_address;